module.exports = __webpack_public_path__ + "static/media/ic_searchtype_country.fdd7c18d.svg";